import { render, staticRenderFns } from "./vbetslip.vue?vue&type=template&id=23d51e4c&"
import script from "./vbetslip.vue?vue&type=script&lang=js&"
export * from "./vbetslip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports